module.exports = __webpack_public_path__ + "img/2019jucan-4.934cda09.jpg";